import { render, staticRenderFns } from "./ResourceDetailsForm.vue?vue&type=template&id=080b49fa&scoped=true&"
import script from "./ResourceDetailsForm.vue?vue&type=script&lang=js&"
export * from "./ResourceDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./ResourceDetailsForm.vue?vue&type=style&index=0&id=080b49fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080b49fa",
  null
  
)

export default component.exports